import { cn } from "../../../lib/utils";
import {
  type ProgressSegment,
  SegmentedProgressBar,
} from "../../segmented-progress-bar";
import { EmptyCell } from "./EmptyCell";

export interface SegmentedProgressCellProps {
  segments: ProgressSegment[] | null;
  className?: string;
}

export const SegmentedProgressCell: React.FC<SegmentedProgressCellProps> = ({
  segments,
  className,
}) => {
  if (!segments || segments.length === 0) {
    return <EmptyCell />;
  }

  return (
    <div className={cn("flex justify-center items-center", className)}>
      <SegmentedProgressBar segments={segments} />
    </div>
  );
};
